/* RESPONSIBLE TEAM: team-reporting */

const config = {
  legend: {
    enabled: true,
    align: 'center',
    margin: 27,
    layout: 'horizontal',
    itemHoverStyle: { color: undefined, cursor: 'pointer' },
    itemStyle: {
      fontSize: '12px',
      fontWeight: 'normal',
      color: 'var(--text-muted)',
    },
    labelFormat: '{name}',
    maxHeight: 70,
  },

  accessibility: {
    enabled: false,
  },

  tooltip: {
    hideDelay: 50,
    snap: 10,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'var(--neutral-border)',
    useHTML: true,
    format: `<b>{point.formattedValue}</b><br/>({point.name})`,
  },

  plotOptions: {
    pie: {
      cursor: 'pointer',
      showInLegend: true,
      innerSize: '60%',
      dataLabels: {
        enabled: false,
        format: `<b>{point.formattedValue}</b><br/>({point.name})`,
        style: {
          fontSize: '12px',
          fontWeight: 'normal',
          textOutline: `1px var(--base-module)`,
          color: 'var(--text-default)',
        },
      },
    },
  },
  lang: {
    thousandsSep: ',',
  },
  credits: {
    enabled: false,
  },
};

export default class DefaultDonutChartConfig {
  declare config: Highcharts.Options;

  constructor() {
    this.config = {
      ...structuredClone(config),
    } as Highcharts.Options;
  }

  setDataLabels() {
    if (this.config.plotOptions?.pie?.dataLabels) {
      if (Array.isArray(this.config.plotOptions.pie.dataLabels)) {
        this.config.plotOptions.pie.dataLabels.forEach((dataLabel) => {
          dataLabel.enabled = true;
        });
      } else {
        this.config.plotOptions.pie.dataLabels.enabled = true;
      }
    }
  }

  setReversedLegend() {
    if (this.config.legend) {
      this.config.legend.reversed = true;
    }
  }

  setChartType(type: string) {
    if (this.config.chart) {
      this.config.chart.type = type;
    } else {
      this.config.chart = { type };
    }
  }

  setColors(colors: string[]) {
    this.config.colors = colors;
  }

  disableLegend() {
    if (this.config.legend) {
      this.config.legend.enabled = false;
    } else {
      this.config.legend = { enabled: false };
    }
  }
}
